<template>
  <div class="guide-info">
    <div class="guide-qr-title">用户信息授权</div>
    <div class="guide-qr-tip">为了更好的提供服务，请授权用户信息</div>
    <button class="guide-qr-btn" @click="handleLogin">立即授权</button>
  </div>
</template>
<script>
export default {
  name: 'LoginBox',
  methods: {
    handleLogin() {
      this.$emit('login');
    }
  },
};
</script>

<style lang="scss" scoped>
.guide-info {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: #fff;
  padding: 5.33vw 0;
  border-radius: 4.266vw 4.266vw 0 0;

  .guide-qr-title {
    font-weight: bold;
    font-size: 18px;
    color: #242424;
  }
  .guide-qr-tip {
    font-size: 17px;
    color: #676769;
    margin: 3vw 0 10vw;
  }
  .guide-qr-btn{
    width: 80.8vw;
    height: 12vw;
    background: #07C160;
    border-radius: 6vw;
    font-size: 18px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-bottom: 5vw;
  }
}
</style>
